import api from "../store/services/api";

export const getDiscountCoupon = (discountCouponId) =>
  api.get(`/discount-coupons/${discountCouponId}`);

export const getDiscountCoupons = (params) =>
  api.get("/discount-coupons/", { params });

export const createDiscountCoupon = (coupon) =>
  api.post("/discount-coupons/", coupon, {
    headers: { "Content-Type": "application/json" },
  });

export const editDiscountCoupon = (coupon, couponId) =>
  api.put(`/discount-coupons/${couponId}/`, coupon, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteDiscountCoupon = (couponId) =>
  api.delete(`/discount-coupons/${couponId}/`);

const DiscountCouponsService = {
  getDiscountCoupon,
  getDiscountCoupons,
  createDiscountCoupon,
  editDiscountCoupon,
  deleteDiscountCoupon,
};

export default DiscountCouponsService;
